import { render, staticRenderFns } from "./DepositAndWithdrawal.vue?vue&type=template&id=bed2bd4e&scoped=true"
import script from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
export * from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./DepositAndWithdrawal.vue?vue&type=style&index=0&id=bed2bd4e&prod&scoped=true&lang=css"
import style1 from "./DepositAndWithdrawal.vue?vue&type=style&index=1&id=bed2bd4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed2bd4e",
  null
  
)

export default component.exports